import { normalizeCode } from './crypto';

/**
 * Join links carry the pairing code in the URL fragment, which never
 * reaches any server (fragments are not sent in HTTP requests).
 */
export function buildJoinUrl(code: string): string {
  return `${window.location.origin}${window.location.pathname}#join=${code}`;
}

export function parseJoinCode(hash: string = window.location.hash): string | null {
  const m = /#join=([0-9A-Za-z-]+)/.exec(hash);
  if (!m) return null;
  const code = normalizeCode(m[1]);
  return code.length >= 8 ? code : null;
}

export function clearJoinHash(): void {
  history.replaceState(null, '', window.location.pathname + window.location.search);
}
